import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconExportShareUpload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12 2.63605C12.1092 2.63605 12.2129 2.65933 12.3064 2.70119L12.4967 2.82374C12.5085 2.83408 12.5199 2.84485 12.5311 2.85605L16.78 7.10495C17.0733 7.39827 17.0733 7.87385 16.78 8.16717C16.4867 8.4605 16.0111 8.4605 15.7178 8.16717L12.7511 5.20051V16.1339C12.7511 16.5487 12.4148 16.885 12 16.885C11.5852 16.885 11.2489 16.5487 11.2489 16.1339V5.20049L8.28223 8.16717C7.98891 8.4605 7.51334 8.4605 7.22001 8.16717C6.92668 7.87385 6.92668 7.39827 7.22001 7.10495L11.4689 2.85605L11.4705 2.85445C11.5401 2.78529 11.6198 2.73256 11.7049 2.69625C11.7955 2.6575 11.8952 2.63605 12 2.63605Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.5 13C3.5 12.5858 3.16421 12.25 2.75 12.25C2.33579 12.25 2 12.5858 2 13V18.23C2 20.3101 3.6885 21.993 5.76968 21.9826C9.03212 21.9663 14.2874 21.9473 18.1944 21.9688C20.2836 21.9803 22 20.2941 22 18.1967V13C22 12.5858 21.6642 12.25 21.25 12.25C20.8358 12.25 20.5 12.5858 20.5 13V18.1967C20.5 19.4543 19.4684 20.4758 18.2026 20.4688C14.2871 20.4473 9.02483 20.4663 5.76217 20.4826C4.51348 20.4889 3.5 19.4798 3.5 18.23V13Z",
		fill: "currentColor"
	})]
});
export { SvgIconExportShareUpload as ReactComponent };
